export default "__VITE_ASSET__CMJQhhnb__"